import { useEffect, useState } from 'react';
import { extractListItemsFromHTML } from '../../../utility/helpers';
import Select from 'react-select';

type OptionType = {
  label: string;
  value: string;
};


const DistanceEdit = ({ value, setModalData }: any) => {

  const [selDistance, setSelDistance] = useState<OptionType[]>([]);
  const [options] = useState<OptionType[]>([
      { value: '0-30 miles', label: '0-30 miles' },
      { value: '0-50 miles', label: '0-50 miles' },
      { value: '0-100 miles', label: '0-100 miles' },
      { value: '0-150 miles', label: '0-150 miles' },
      { value: 'Not Applicable', label: 'Not Applicable' },
  ]);

  useEffect(() => {
    const parsedValue = extractListItemsFromHTML(value);
    if (parsedValue?.length > 0) {
      const parsedCerts = parsedValue.map((item: string) => ({
        label: item,
        value: item,
      }));
      setSelDistance(parsedCerts);
    }
  }, [value]);

  useEffect(() => {
    if (setModalData && typeof setModalData === 'function') {
      if (selDistance.length === 0) {
        setModalData('');
      } else {
        const htmlList = `<ul>${selDistance
          .map((item) => `<li>${item.label}</li>`)
          .join('')}</ul>`;
        setModalData(htmlList);
      }
    }
  }, [selDistance, setModalData]);
  
  return (
    <div>
      <Select
         isMulti
          classNamePrefix="custom-select"
          onChange={(option: any) => setSelDistance(option)}
          options={options}
          value={selDistance}
          placeholder="Select Distance"
      />
    </div>
  );
};

export default DistanceEdit;
